module.exports = __webpack_public_path__ + "img/contentsBellIcon_on.84677209.svg";